import classNames from 'classnames';

import styles from './OrderSuccessButton.module.scss';

import { StatusEnum } from '@/shared/api';
import { Button } from '@/shared/ui-kit/Button/Button';

interface OrderSuccessButtonProps {
  orderId?: string | number;
  readyTime?: string;
  onClick?: () => void;
  status?: StatusEnum;
}

export const OrderSuccessButton: React.FC<OrderSuccessButtonProps> = ({
  orderId,
  readyTime,
  onClick,
  status,
}: OrderSuccessButtonProps) => {
  const isAccepted = status === 'ACCEPTED';
  return (
    <div className={styles.container}>
      <Button
        variant="success"
        className={classNames(styles.button, {
          [styles.buttonShimmer]: !isAccepted,
        })}
        onClick={onClick}
      >
        <span className={styles.title}>
          Заказ {orderId} {isAccepted ? 'принят' : 'оплачен'}
        </span>
        <span className={styles.subTitle}>
          {isAccepted ? `Подходите к ${readyTime}` : 'Передаем его на кассу'}
        </span>
      </Button>
    </div>
  );
};
